import { create } from 'zustand';
import { getState, useState } from '@/framework';
import { IExportState, StateType } from '@/version-types';

/** 状态 */
interface IState {
    isCropImage: boolean;
    isAutoCutoutLayer: boolean;
    isOperation: boolean;
}

/** 动作 */
interface IAction {
    setIsCropImage: (isCropImage: boolean) => void;
    setIsAutoCutoutLayer: (isAutoCutoutLayer: boolean) => void;
    setIsOperation: (isOperation: boolean) => void;
}

/** 存储类型 */
interface IStore extends IState, IAction {}

/** 初始化状态 */
export function getInitialState() {
    return {
        isCropImage: false,
        isAutoCutoutLayer: true,
        isOperation: false,
    };
}

/** 创建存储 */
const createState = () => {
    const store = create<IStore>((set) => ({
        ...getInitialState(),

        setIsCropImage: (isCropImage) => {
            set({ isCropImage });
        },
        setIsAutoCutoutLayer: (isAutoCutoutLayer) => {
            set({ isAutoCutoutLayer });
        },
        setIsOperation: (isOperation) => {
            set({ isOperation });
        },
    }));

    return store;
};

/** 存储名称 */
const name = 'crop-img-state';

/** 存储类型 */
type ModuleType = StateType<IStore, typeof name>;

/** hook 获取存储 */
export const useCropImgState = () => {
    return useState<ModuleType>()[name];
};

/** 通过 id 获取存储 */
export const getCropImgState = (identity: string) => {
    return getState<ModuleType>(identity)[name].getState();
};

const exportState: IExportState = {
    name,
    createState,
};

export default exportState;
